import { Button } from 'antd';
import { ShieldAlert, UserPlus } from 'lucide-react';
import { Navigate } from 'react-router';
import { EmptyState } from '../../../shared/components/EmptyState';
import { PageHeader } from '../../../shared/components/PageHeader';
import { TableSkeleton } from '../../../shared/components/TableSkeleton';
import { CreateUserDrawer } from '../components/CreateUserDrawer';
import { useUsersPage } from '../hooks/use-users-page';
import { UsersTable } from '../components/UsersTable';
import { sectionTrail } from '../../../shared/components/section-trail';

export function UsersPage() {
  const { users, roleOptions, columns, createDrawerOpen, setCreateDrawerOpen } = useUsersPage();

  if (users.state.status === 'forbidden') return <Navigate to="/" replace />;

  return (
    <>
      <PageHeader
        breadcrumbs={sectionTrail('users')}
        title="Users"
        description="Office users, their roles and status. Open a user to reset their password, deactivate them or act as them."
        actions={
          <Button
            type="primary"
            icon={<UserPlus className="size-4" />}
            onClick={() => {
              users.resetCreateError();
              setCreateDrawerOpen(true);
            }}
          >
            Create user
          </Button>
        }
      />
      {users.state.status === 'error' && (
        <EmptyState icon={ShieldAlert} title="Couldn't load users" description="Something went wrong loading the users list. Try reloading the page." />
      )}
      {users.state.status === 'loading' && <TableSkeleton label="Loading users" withSearch />}
      {users.state.status === 'loaded' && <UsersTable page={users.state.page} columns={columns} list={users.list} isRefreshing={users.isRefreshing} />}
      <CreateUserDrawer
        open={createDrawerOpen}
        roleOptions={roleOptions}
        error={users.createError}
        submitting={users.creating}
        onCreate={users.create}
        onClose={() => setCreateDrawerOpen(false)}
      />
    </>
  );
}
